import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../../public/fonts/averta/Averta-bold.woff2%22,%22weight%22:%22700%22,%22style%22:%22normal%22},{%22path%22:%22../../../public/fonts/averta/Averta-light.woff2%22,%22weight%22:%22300%22,%22style%22:%22normal%22},{%22path%22:%22../../../public/fonts/averta/Averta-semibold.woff2%22,%22weight%22:%22600%22,%22style%22:%22normal%22},{%22path%22:%22../../../public/fonts/averta/Averta-thin.woff2%22,%22weight%22:%22100%22,%22style%22:%22normal%22}],%22variable%22:%22--font-family-averta%22}],%22variableName%22:%22avertaFont%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'avertaFont', 'avertaFont Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
